import axios from 'axios';
import AuthService from './auth-header';

let API_URL = ''
if (process.env.NODE_ENV === "production") {
  API_URL = 'https://ats.sattvahuman.in/api/';
} else {
  API_URL = 'http://192.168.0.30:5000/api/';
}

class EmployeeSurveyService {
  // Save draft response
  async saveDraftResponse(data) {
    try {
      const res = await axios.post(API_URL + 'survey-responses/draft', {
        response: data.response,
        responseId: data.responseId,
        emp_id: data.emp_id,
        isAnonymous: data.isAnonymous
      }, {
        headers: AuthService.authHeader()
      })
      console.log(res.data)
      return res.data
    } catch (err) {
      console.log(err.response)
      return err.response
    }
  }

  // Submit response
  async submitResponse(data) {
    try {
      console.log('data', data)
      const res = await axios.post(API_URL + 'survey-responses/submit', {
        response: data.response,
        responseId: data.responseId,
        emp_id: data.response.empId,
        isAnonymous: data.isAnonymous
      }, {
        headers: AuthService.authHeader()
      })
      console.log(res.data)
      return res.data
    } catch (err) {
      console.log(err.response)
      return err.response
    }
  }

  // Get response by employee ID
  async getResponseByEmployeeId(empId) {
    try {
      const res = await axios.get(API_URL + 'survey-responses/employee/' + empId, {
        headers: AuthService.authHeader()
      })
      console.log(res.data)
      return res.data
    } catch (err) {
      console.log(err.response)
      return err.response
    }
  }

  // Get response by response ID
  async getResponseByResponseId(responseId) {
    try {
      const res = await axios.get(API_URL + 'survey-responses/' + responseId, {
        headers: AuthService.authHeader()
      })
      console.log(res.data)
      return res.data
    } catch (err) {
      console.log(err.response)
      return err.response
    }
  }

  // Get all responses with optional filters
  async getAllResponses(page, limit, status, isAnonymous, dateFrom, dateTo) {
    try {
      console.log('getAllResponses: ', page.page, page.limit, status, isAnonymous, dateFrom, dateTo)
      let url = API_URL + 'survey-responses?'
      if (page) url += 'page=' + page.page + '&'
      if (limit) url += 'limit=' + page.limit + '&'
      if (status) url += 'status=' + status + '&'
      if (isAnonymous !== undefined) url += 'isAnonymous=' + isAnonymous + '&'
      if (dateFrom) url += 'dateFrom=' + dateFrom + '&'
      if (dateTo) url += 'dateTo=' + dateTo + '&'

      // Remove trailing '&' if present
      url = url.replace(/&$/, '')

      const res = await axios.get(url, {
        headers: AuthService.authHeader()
      });
      console.log(res.data)
      return res.data
    } catch (err) {
      console.log(err.response)
      return err.response
    }
  }

  // Get response statistics
  async getResponseStatistics() {
    try {
      const res = await axios.get(API_URL + 'survey-responses/statistics', {
        headers: AuthService.authHeader()
      })
      console.log(res)
      return res.data
    } catch (err) {
      console.log(err.response)
      return err.response
    }
  }

  // Delete response
  async deleteResponse(id) {
    try {
      const res = await axios.delete(API_URL + 'survey-responses/' + id, {
        headers: AuthService.authHeader()
      });
      console.log(res.data)
      return res.data
    } catch (err) {
      console.log(err.response)
      return err.response
    }
  }

}

export default new EmployeeSurveyService() 